import { Builder, builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

import customCardConfig from 'components/CustomCard/config';
import switchbackConfig from 'components/Switchback/config';

import type { Component } from '@builder.io/sdk';

// Connector pages render Builder symbols with a raw <BuilderComponent> (see
// template/connectors/Application.tsx and Helper.tsx) and never load the full
// editor ComponentGenerator, so the SDK had no registration for the Custom Card
// and Switchback blocks inside those symbols and rendered them empty
// ("Missing registration for Custom Card / switchback"). Register just those two
// so the symbols render fully, without pulling the whole component config graph
// (and its bundle weight) into the connector pages. Import this module for its
// side effect wherever those symbols are rendered.
// The API key has to be set on THIS singleton specifically. Connector pages do
// initialise Builder, but via utils/builder/builder.sdk.ts, which inits the
// `@builder.io/sdk` instance for server-side data fetching. The symbols are
// rendered on the client by `@builder.io/react`'s <BuilderComponent> (lazily
// imported in template/connectors/Application.tsx and Helper.tsx), and that
// package carries its own separate `builder` instance which nothing was
// initialising -- so every connector page logged two "Looks like the Builder
// SDK has not been initialized properly (your API key has not been set)"
// console errors. Same module-scope init the other client entry points use
// (ComponentGenerator, RenderBuilderContent, useBuilderReference).
builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY || '');

const symbolComponents = [
  { component: dynamic(() => import('components/CustomCard')), config: customCardConfig },
  { component: dynamic(() => import('components/Switchback')), config: switchbackConfig },
];

symbolComponents.forEach(({ component, config }) => {
  Builder.registerComponent(component, config as Component);
});
